import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from '@thehubz/client/core';
import { CollectionPublishingComponent } from './collection-publishing/collection-publishing.component';
import { CollectionComponent } from './collection.component';
import { CollectionsListComponent } from './collections-list/collections-list.component';

const routes: Routes = [
  {
    path: '',
    component: CollectionComponent,
    canActivate: [AuthenticationGuard],
    children: [
      { path: '', redirectTo: 'my-collection', pathMatch: 'full' },
      {
        path: 'my-collection',
        data: { label: $localize`My collections` },
        component: CollectionsListComponent,
      },
      {
        path: 'published',
        data: { label: $localize`Public collections` },
        component: CollectionPublishingComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CollectionsRoutingModule {}
